// extracted by mini-css-extract-plugin
export default {"backButton":"CorreoElectronico_backButton__o472M","formEmail":"CorreoElectronico_formEmail__FmZjm","secondLine":"CorreoElectronico_secondLine__J+iBk"};